<template lang="pug">
  .empty-results.column.center.width-100.m4-top-14
    img.empty-icon.m-bottom-2(src='@/assets/ic_search_empty.png' alt='No Results')
    p.error-title.title-medium.bold.dark-gray.m-bottom-2 {{ $t('dashboard.errors.noResult') }}
    p.error-explanation.text-big.dark-gray {{ $t('dashboard.errors.emptySearchResultExplanation') }}
    router-link.text-small.blue.m-top-4(to='/feed') {{ $t('dashboard.backToFeed') }}
</template>

<script>

export default {

}
</script>

<style lang="scss" scoped>

.empty-icon {
  margin-top: 8px;
  max-width: 204px;
}
.error-title {
  max-width: 304px;
}
.error-explanation {
  max-width: 660px;
  text-align: center;
}
</style>
